import axios from "axios";
import { ENDPOINT } from "constants/environment";
import { encryptData } from "helpers";
import { decryptData } from "helpers";
import { getHeaderConfig } from "helpers";
import { consoleLog } from "helpers";

export const getNotificationApi = async (
  { pageIndex, skip },
  isLoading,
  accessJWT
) => {
  try {
    isLoading(true);

    const body = {
      skip: pageIndex + 1,
      limit: skip,
    };

    const config = getHeaderConfig(null, accessJWT);
    const response = await axios.post(
      `${ENDPOINT}/app/v1/searchNotification`,
      encryptData(body),
      config
    );

    const parsedResponseData = JSON.parse(decryptData(response?.data));
    consoleLog([parsedResponseData, "response123"]);
    if (parsedResponseData && parsedResponseData?.statusCode === 200) {
      if (isLoading) isLoading(false);

      return parsedResponseData?.data;
    }

    if (isLoading) isLoading(false);
    isLoading(false);
    throw Error;
  } catch (error) {
    isLoading(false);
    console.error("Error fetching data:", error);
    return null;
  }
};

export const getFilterNotificationAPI = async (
  { searchQuery, pageIndex, limit },
  isLoading,
  accessJWT
) => {
  try {
    isLoading(true);
    const config = getHeaderConfig(null, accessJWT);

    const body = {
      searchQuery,
      skip: pageIndex + 1,
      limit: limit,
    };

    const response = await axios.post(
      `${ENDPOINT}/app/v1/searchNotification`,
      encryptData(body),
      config
    );

    consoleLog([response, "res"]);

    const parsedResponseData = JSON.parse(decryptData(response?.data));

    if (parsedResponseData?.statusCode === 200) {
      if (isLoading) isLoading(false);
      consoleLog([parsedResponseData.data, "searchRes"]);
      consoleLog([
        parsedResponseData.data.pagination?.totalPages,
        "parsedResponseData.data.pagination?.totalPages",
      ]);

      return {
        data: parsedResponseData?.data.data,
        totalPages: parsedResponseData.data.pagination?.totalPages,
      };
    }

    if (isLoading) isLoading(false);
    throw new Error("Error fetching data");
  } catch (error) {
    isLoading(false);
    console.error("Error fetching data:", error);
    return { data: [], totalPages: 0 };
  }
};
